import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SmileSelector',
  emits: ["input"],
  setup(__props, { emit }) {

    const smiles = ['😁', '😅', '😊', '😇','🥰', '🤩', '🤑', '🤔', '🫡', '🤨', '😬', '😴', '🤯', '🤓', '😎', '🧐', '😳', '😡', '😈', '💀']

    

    const emitInput = (emoji : string) => {
        emit("input", emoji)
    }

return { __sfc: true,smiles, emit, emitInput }
}

})